export { default } from './part-form-input';
